import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
// import { useMutation } from '@apollo/client';
// import { Modal } from '@madeeasy/universal-login';
// import { useSearchParams } from 'next/navigation';
import GET_ENTITY_BY_SLUG from '../gql/queries/get-entity-by-slug.gql';
import GET_COURSE_GROUP_BY_SLUG from '../gql/queries/course-group.gql';
import GET_EVENT_BY_SLUG from '../gql/queries/get-event-by-slug.gql';
import GET_PAGE_CONTENT_BY_SLUG from '../gql/queries/get-page-content-by-slug.gql';
import CourseLanding from '../components/course-landing';
import EventRegisterForm from '../components/promotional-events/EventRegisterForm';
import HeaderFooterLayout from '../components/home/layouts/HeaderFooterLayout';
import LayoutComponent from '../components/home/layouts/LayoutComponent';
import SEOHead from '../components/seo-head';
import PageHeader from '../components/shared/PageHeader';
import { initializeApollo } from '../../apollo-ssr';
import { getServerSideToken } from '../utils/auth-utils';
import { useMiscellaneousData } from '../contexts/ssr-miscellaneous-context';
import parseSlugWithLanguage from '../utils/slug-parser';
import fetchHeaderFooterData from '../utils/header-footer-fetcher';
import GeneralWebPage from '../components/general-web-page';
import ListPage from '../components/lists';
// import CREATE_CALL_REQUEST from '../gql/mutations/counselling.gql';
// import { ToastContext } from '../contexts/toast-context-with-provider';
// import { useUser } from '../contexts/ssr-user-context';
// import Popup from '../components/shared/Popup';
// import Spinner from '../icons/spinner';
import HtmlSnippet from '../components/shared/html-snippet'; // for callback request form

export default function DynamicPage({
  entityType,
  entityId,
  initialCourseGroupData,
  initialCourseGroupEntityData,
  initialEventData,
  initialPageData,
  slug,
  headerData,
  footerData,
  headerHTMLContent,
  footerHTMLContent,
  renderMode,
  entityMeta,
  breadcrumb,
}) {
  console.log('entityMeta:', entityMeta);
  const { miscellaneousData } = useMiscellaneousData();
  const { isPrepPrefixed, hostname } = miscellaneousData || {};

  // Helper function to extract path from URL
  const getPathFromUrl = (url) => {
    if (!url) return '/';
    const path = url.replace(/^(https?:\/\/)?(www\.)?[^/]+/, '');
    return path || '/';
  };

  // Render breadcrumb JSX from breadcrumb array
  const renderBreadcrumb = (breadcrumbArray) => {
    if (!breadcrumbArray || breadcrumbArray.length === 0) return null;

    return (
      <span>
        {breadcrumbArray.map((item, index) => {
          const isLast = index === breadcrumbArray.length - 1;
          const path = getPathFromUrl(item.url);

          return (
            <React.Fragment key={`${item.url}-${item.name}`}>
              {!isLast ? (
                <Link href={path}>{item.name}</Link>
              ) : (
                <span className="text-gray-700">{item.name}</span>
              )}
              {!isLast && ' / '}
            </React.Fragment>
          );
        })}
      </span>
    );
  };

  // Canonical URL logic:
  // 1. If entityMeta.canonicalUrl exists, it takes precedence (will be passed to SEOHead)
  // 2. If page is /prep prefixed, canonical should point to non-prefixed version
  // 3. If page is non-prefixed, canonical should point to itself
  const getCanonicalUrl = () => {
    if (!slug || !hostname) return undefined;

    // Server-provided canonical URL takes precedence (handled in SEOHead via entityMeta)
    if (entityMeta?.canonicalUrl) {
      return undefined; // Let SEOHead handle it from entityMeta.canonicalUrl
    }

    // For /prep prefixed pages, canonical points to non-prefixed version
    if (isPrepPrefixed) {
      return `https://${hostname}/${slug}`;
    }

    // For non-prefixed pages, canonical points to itself
    return `https://${hostname}/${slug}`;
  };

  const canonicalUrl = getCanonicalUrl();

  // login
  // login popup
  // const [showLogin, setShowLogin] = useState(false);
  // const { showToast } = useContext(ToastContext);
  // const toggleModal = () => {
  //   setShowLogin(false);
  // };
  // const { user } = useUser();
  // const searchParams = useSearchParams();
  // const router = useRouter();
  // const callBackRequest = searchParams.get('callBackRequest');
  // const redirectToCall = router.query.redirectTo;
  // call back request
  // eslint-disable-next-line no-unused-vars
  // const [createCounselling, { loading: mutationLoading, error: mutationError }] = useMutation(CREATE_CALL_REQUEST);

  // const openLoginform = () => {
  //   const targetPath = router.asPath;
  //   const fullRedirectUrl = `https://${miscellaneousData?.hostname}${targetPath}`;
  //    // Add your custom param here
  //    fullRedirectUrl.searchParams.set('useLoggedIn', 'true');
  //   const params = new URLSearchParams(searchParams.toString());
  //   params.set('redirectTo', fullRedirectUrl);
  //   const newUrl = `${window.location.pathname}?${params.toString()}`;
  //   // `prep${pathname}?${params.toString()}`;
  //   window.history.replaceState(null, '', newUrl);
  //   setShowLogin(true);
  // };

  // const [formLoader, setFormLoader] = useState(false);
  // const [showFormPopup, setShowFormPopup] = useState(false);
  // const openLoginform = () => {
  //   const isPrefixed = process.env.NEXT_PUBLIC_USE_BASE_PATH === 'true';
  //   const targetPath = isPrefixed ? `/prep${router.asPath}` : router.asPath;
  //   // const targetPath = `/prep${router.asPath}`;

  //   const redirectUrl = new URL(
  //     `https://${miscellaneousData?.hostname}${targetPath}`,
  //   );

  //   redirectUrl.searchParams.set('callBackRequest', 'true');

  //   const params = new URLSearchParams(searchParams.toString());
  //   params.set('redirectTo', redirectUrl.toString());

  //   const newUrl = `${window.location.pathname}?${params.toString()}`;

  //   window.history.replaceState(null, '', newUrl);

  //   // setFormLoader(true); // loader ON
  //   setShowLogin(true);
  // };

  // const requestCallBackEnroll = () => {
  //   if (user?.id) {
  //     try {
  //       const result = createCounselling({
  //         variables: {
  //           input: {
  //             entityId,
  //             entityType,
  //             name: user?.name,
  //             mobile: user?.phone,
  //             email: user?.email,
  //           },
  //         },
  //       });
  //       if (result) {
  //         showToast('Counselling request submitted successfully!');
  //         setShowFormPopup(false);
  //         // Remove query params
  //         router.replace(router.asPath.split('?')[0], undefined, { shallow: true });
  //         // redirectToThankYou();
  //       }
  //     } catch {
  //       // mutation failed silently
  //     }
  //     setShowLogin(false);
  //   } else {
  //     openLoginform();
  //   }
  // };
  // useEffect(() => {
  //   const handleClick = (e) => {
  //     const enrollButton = e.target.closest('.enroll-now-react');

  //     if (enrollButton) {
  //       if (user?.id) {
  //         setShowFormPopup(true);
  //       } else {
  //         openLoginform();
  //       }
  //     }
  //   };

  //   document.addEventListener('click', handleClick);

  //   return () => {
  //     document.removeEventListener('click', handleClick);
  //   };
  // }, [user]);
  // ---end-----

  // useEffect(() => {
  //   if (callBackRequest === 'true' && user?.id) {
  //     setShowFormPopup(true);
  //   // setFormLoader(false);
  //   }
  // }, [callBackRequest]);
  // useEffect(() => {
  //   const handleLoginSuccess = () => {
  //     setFormLoader(true);
  //   };

  //   window.addEventListener('loginSuccess', handleLoginSuccess);

  //   return () => {
  //     window.removeEventListener('loginSuccess', handleLoginSuccess);
  //   };
  // }, []);
  // useEffect(() => {
  //   if (redirectToCall) {
  //     setFormLoader(true);
  //     // setFormLoader(false);
  //   }
  // }, [redirectToCall]);

  // const handleCloseFormPopup = () => setShowFormPopup(false);
  // const enrollFormContent = (
  //   <EnrollForm user={user} requestCallBackEnroll={requestCallBackEnroll} />
  // );

  // Render appropriate component based on entity type
  if (entityType === 'course-group') {
    const courseGroupData = initialCourseGroupData?.getCourseGroupBySlug;
    // const pageHeading = entityMeta?.breadcrumbTitle || breadcrumb?.[breadcrumb.length - 1]?.name || '';

    return (
      <>
        <SEOHead data={entityMeta} canonicalUrl={canonicalUrl} />
        <HeaderFooterLayout
          paddingClass="p-2"
          headerData={headerData}
          footerData={footerData}
          headerHTMLContent={headerHTMLContent}
          footerHTMLContent={footerHTMLContent}
          renderMode={renderMode}
        >
          <PageHeader
            marginClass="md:ml-12 ml-4"
            // pageHeading={pageHeading}
            breadCrumb={renderBreadcrumb(breadcrumb)}
          />
          <CourseLanding
            // slug={slug}
            initialCourseGroupData={courseGroupData}
            initialCourseGroupEntityData={initialCourseGroupEntityData}
          />
        </HeaderFooterLayout>
      </>
    );
  }

  if (entityType === 'promotional-event') {
    // const pageHeading = entityMeta?.breadcrumbTitle || breadcrumb?.[breadcrumb.length - 1]?.name || '';

    return (
      <>
        <SEOHead data={entityMeta} canonicalUrl={canonicalUrl} />
        <LayoutComponent>
          <PageHeader
            marginClass="md:ml-12 ml-4"
            // pageHeading={pageHeading}
            breadCrumb={renderBreadcrumb(breadcrumb)}
          />
          <EventRegisterForm data={initialEventData} />
        </LayoutComponent>
      </>
    );
  }

  if (entityType === 'full-page') {
    const htmlContent = initialPageData?.getPageContentBySlug?.htmlContent;
    return (
      <>
        <SEOHead data={entityMeta} canonicalUrl={canonicalUrl} />
        <HtmlSnippet entityId={entityId} entityType={entityType} postLoginAction={entityMeta?.postLoginAction} />
        {/* eslint-disable-next-line react/no-danger */}
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
        {/* {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
        <Popup
          showPopup={showFormPopup}
          messageData={enrollFormContent}
          popupFor="MyCourse"
          onPopupClose={handleCloseFormPopup}
          batchHeading="Request a call Back"
          divwidth="!max-w-[63%] lg:w-auto w-full"
        /> */}
        {/* {formLoader && (
        <div className="fixed inset-0 top-0 flex items-center justify-center bg-black/30 z-40">
          <Spinner />
        </div>
        )} */}
      </>
    );
  }

  if (entityType === 'general-web-page') {
    const htmlContent = initialPageData?.getPageContentBySlug?.htmlContent;
    // const pageHeading = entityMeta?.breadcrumbTitle || breadcrumb?.[breadcrumb.length - 1]?.name || '';

    return (
      <>
        <SEOHead data={entityMeta} canonicalUrl={canonicalUrl} />
        <HtmlSnippet entityId={entityId} entityType={entityType} postLoginAction={entityMeta?.postLoginAction} />

        <HeaderFooterLayout
          paddingClass="p-2"
          headerData={headerData}
          footerData={footerData}
          headerHTMLContent={headerHTMLContent}
          footerHTMLContent={footerHTMLContent}
          renderMode={renderMode}
        >
          <PageHeader
            marginClass="md:ml-12 ml-4"
            breadCrumb={renderBreadcrumb(breadcrumb)}
          />
          <GeneralWebPage htmlContent={htmlContent} />
          {/* <div dangerouslySetInnerHTML={{ __html: htmlContent }} /> */}
        </HeaderFooterLayout>
        {/* {showLogin ? <Modal toggleModal={toggleModal} text="Login" /> : null}
        <Popup
          showPopup={showFormPopup}
          messageData={enrollFormContent}
          popupFor="MyCourse"
          onPopupClose={handleCloseFormPopup}
          batchHeading="Request a call Back"
          divwidth="!max-w-[63%] lg:w-auto w-full"
        />
        {formLoader && (
        <div className="fixed inset-0 top-0 flex items-center justify-center bg-black/30 z-40">
          <Spinner />
        </div>
        )} */}
      </>
    );
  }

  if (entityType === 'list') {
    return (
      <>
        <SEOHead data={entityMeta} canonicalUrl={canonicalUrl} />
        <HeaderFooterLayout
          paddingClass="p-2"
          headerData={headerData}
          footerData={footerData}
          headerHTMLContent={headerHTMLContent}
          footerHTMLContent={footerHTMLContent}
          renderMode={renderMode}
        >
          <PageHeader
            marginClass="ml-20"
            breadCrumb={renderBreadcrumb(breadcrumb)}
          />
          <ListPage listId={entityId} />
        </HeaderFooterLayout>
      </>
    );
  }

  // Fallback for unsupported entity types
  return null;
}

DynamicPage.propTypes = {
  entityType: PropTypes.string,
  entityId: PropTypes.string,
  slug: PropTypes.string,
  initialCourseGroupData: PropTypes.object,
  initialCourseGroupEntityData: PropTypes.object,
  initialEventData: PropTypes.object,
  initialPageData: PropTypes.object,
  headerData: PropTypes.object,
  footerData: PropTypes.object,
  headerHTMLContent: PropTypes.string,
  footerHTMLContent: PropTypes.string,
  renderMode: PropTypes.object,
  entityMeta: PropTypes.shape({
    canonicalUrl: PropTypes.string,
    breadcrumbTitle: PropTypes.string,
    postLoginAction: PropTypes.string,
  }),
  breadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

DynamicPage.defaultProps = {
  entityType: null,
  entityId: null,
  slug: null,
  initialCourseGroupData: null,
  initialCourseGroupEntityData: null,
  initialEventData: null,
  initialPageData: null,
  headerData: null,
  footerData: null,
  headerHTMLContent: null,
  footerHTMLContent: null,
  renderMode: null,
  entityMeta: null,
  breadcrumb: [],
};

export async function getServerSideProps(context) {
  // Block catch-all routes on prefixed deployment in production
  const isPrefixed = process.env.NEXT_PUBLIC_USE_BASE_PATH === 'true';
  const isProduction = process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD';

  if (isPrefixed && isProduction) {
    return {
      notFound: true,
    };
  }

  let hostname;
  if (context && context.req && context.req.headers && context.req.headers.host) {
    hostname = context.req.headers.host;
  } else {
    hostname = 'nextias.com';
  }

  const userToken = getServerSideToken(context.req);
  const apolloClient = initializeApollo(null, userToken, hostname);

  if (!userToken) {
    // Anonymous → allow CDN caching
    context.res.setHeader(
      'Cache-Control',
      'public, s-maxage=1800, stale-while-revalidate=60',
    );
  }

  // Extract slug from catch-all route
  let slug;
  let lang;
  // if (context && context.params && context.params.slug) {
  //   // For catch-all routes, slug is an array
  //   slug = Array.isArray(context.params.slug)
  //     ? context.params.slug.join('/')
  //     : context.params.slug;
  // } else {
  //   slug = null;
  // }

  if (context.params.slug) {
    const rawSlug = context.params.slug;
    const parsed = parseSlugWithLanguage(rawSlug);
    slug = parsed.slug;
    lang = parsed.lang;
  }
  try {
    // First, fetch the entity to determine its type
    const entityResult = await apolloClient.query({
      query: GET_ENTITY_BY_SLUG,
      variables: {
        slug,
        lang,
      },
      // skip: !slug,
      errorPolicy: 'ignore',
    });
    // console.log({ entityResult, slug, lang, apolloClient });

    const entity = entityResult?.data?.getEntityBySlug;

    // Handle redirect entity type
    if (entity?.entityType === 'redirect' && entity?.redirectTo) {
      return {
        redirect: {
          destination: `/${entity.redirectTo}`,
          statusCode: 302, // Temporary redirect
        },
      };
    }

    // Handle course-group entity type
    if (entity?.entityType === 'course-group') {
      // Fetch course group data
      const courseGroupResult = await apolloClient.query({
        query: GET_COURSE_GROUP_BY_SLUG,
        variables: {
          slug,
          lang: lang || 'en',
        },
        errorPolicy: 'ignore',
      });

      const {
        headerData,
        footerData,
        headerHTMLContent,
        footerHTMLContent,
        renderMode,
      } = await fetchHeaderFooterData(apolloClient, lang || 'en');

      const initialCourseGroupEntityData = entityResult.data;
      const initialCourseGroupData = courseGroupResult.data;

      return {
        props: {
          entityType: entity.entityType,
          initialCourseGroupData,
          initialCourseGroupEntityData,
          headerData,
          footerData,
          headerHTMLContent,
          footerHTMLContent,
          renderMode,
          slug,
          entityMeta: entity.meta || null,
          breadcrumb: entity.breadcrumb || [],
          apolloState: apolloClient.cache.extract(),
        },
      };
    }

    // handle list entity type
    if (entity?.entityType === 'list') {
      const {
        headerData,
        footerData,
        headerHTMLContent,
        footerHTMLContent,
        renderMode,
      } = await fetchHeaderFooterData(apolloClient, lang || 'en');

      const initialListEntityData = entityResult.data;

      return {
        props: {
          entityType: entity.entityType,
          entityId: initialListEntityData?.getEntityBySlug?.id,
          headerData,
          footerData,
          headerHTMLContent,
          footerHTMLContent,
          renderMode,
          slug,
          entityMeta: entity.meta || null,
          breadcrumb: entity.breadcrumb || [],
          apolloState: apolloClient.cache.extract(),
        },
      };
    }

    // Handle promotional-event entity type
    if (entity?.entityType === 'promotional-event') {
      // Fetch promotional event data
      const eventResult = await apolloClient.query({
        query: GET_EVENT_BY_SLUG,
        variables: {
          slug,
        },
        skip: !slug,
        errorPolicy: 'ignore',
      });

      const initialEventData = eventResult?.data || null;

      return {
        props: {
          entityType: entity.entityType,
          initialEventData,
          slug,
          entityMeta: entity.meta || null,
          breadcrumb: entity.breadcrumb || [],
          apolloState: apolloClient.cache.extract(),
        },
      };
    }

    // Handle full-page entity type
    if (entity?.entityType === 'full-page') {
      // Fetch page content data
      const pageContentResult = await apolloClient.query({
        query: GET_PAGE_CONTENT_BY_SLUG,
        variables: {
          slug,
          lang: lang || 'en',
        },
        errorPolicy: 'ignore',
      });

      const initialPageData = pageContentResult?.data || null;
      return {
        props: {
          entityType: entity.entityType,
          entityId: entity.id,
          initialPageData,
          slug,
          entityMeta: entity.meta || null,
          breadcrumb: entity.breadcrumb || [],
          apolloState: apolloClient.cache.extract(),
        },
      };
    }

    // Handle general-web-page entity type
    if (entity?.entityType === 'general-web-page') {
      // Fetch page content data
      const pageContentResult = await apolloClient.query({
        query: GET_PAGE_CONTENT_BY_SLUG,
        variables: {
          slug,
          lang: lang || 'en',
        },
        errorPolicy: 'ignore',
      });

      const {
        headerData,
        footerData,
        headerHTMLContent,
        footerHTMLContent,
        renderMode,
      } = await fetchHeaderFooterData(apolloClient, lang || 'en');

      const initialPageData = pageContentResult?.data || null;
      return {
        props: {
          entityType: entity.entityType,
          entityId: entity.id,
          initialPageData,
          headerData,
          footerData,
          headerHTMLContent,
          footerHTMLContent,
          renderMode,
          slug,
          entityMeta: entity.meta || null,
          breadcrumb: entity.breadcrumb || [],
          apolloState: apolloClient.cache.extract(),
        },
      };
    }

    // For any other entity type, redirect to 404
    return {
      notFound: true,
    };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error fetching entity data:', error);
    return {
      notFound: true,
    };
  }
}
